import Doorphone from '@/services/api/doorphone';

export default {
  namespaced: true,
  state: {
    doorphones: [],
    mapDoorphones: [],
    mfDoorphones: [],
    doorphonesExpanded: [],
    doorphone: {},
    doorphoneEditDoorphone: {},
    doorphoneEditInfo: {},
    doorphoneExpanded: {},
    rules: [],
    soundSettings: {},
    timeSettings: {},
    journalsip: [],
    journalSipAllBeward: [],
    journalSipAllExtended: [],
    cities: [],
    streets: [],
    houses: [],
    addresses: [],
    districts: [],
    textmessage: {},
    freeKeys: [],
    freeUniversalKeys: [],
    relay: {},
    sipHistory: [],
    actions: [],
    tempCodeProvisionHistory: [],
    audio: [],
    detailAudio: {},
    logs: [],
    logsStatistics: [],
  },
  getters: {
    doorphones: state => state.doorphones,
    mapDoorphones: state => state.mapDoorphones,
    mfDoorphones: state => state.mfDoorphones,
    doorphonesExpanded: state => state.doorphonesExpanded,
    logs: state => state.logs,
    logsStatistics: state => state.logsStatistics,
    doorphone: state => state.doorphone,
    doorphoneEditDoorphone: state => state.doorphoneEditDoorphone,
    doorphoneEditInfo: state => state.doorphoneEditInfo,
    doorphoneExpanded: state => state.doorphoneExpanded,
    rules: state => state.rules,
    soundSettings: state => state.soundSettings,
    timeSettings: state => state.timeSettings,
    journalsip: state => state.journalsip,
    journalSipAllBeward: state => state.journalSipAllBeward,
    journalSipAllExtended: state => state.journalSipAllExtended,
    cities: state => state.cities,
    streets: state => state.streets,
    houses: state => state.houses,
    addresses: state => state.addresses,
    districts: state => state.districts,
    textmessage: state => state.textmessage,
    freeKeys: state => state.freeKeys,
    freeUniversalKeys: state => state.freeUniversalKeys,
    relay: state => state.relay,
    sipHistory: state => state.sipHistory,
    actions: state => state.actions,
    tempCodeProvisionHistory: state => state.tempCodeProvisionHistory,
    audio: state => state.audio,
    detailAudio: state => state.detailAudio,
  },
  mutations: {
    setDoorphones: (state, payload) => {
      state.doorphones = payload;
    },
    setMapDoorphones: (state, payload) => {
      state.mapDoorphones = payload;
    },
    setMfDoorphones: (state, payload) => {
      state.mfDoorphones = payload;
    },
    setDoorphonesExpanded: (state, payload) => {
      state.doorphonesExpanded = payload;
    },
    setSipStatusLogs: (state, payload) => {
      state.logs = payload;
    },
    setLogsStatistics: (state, payload) => {
      state.logsStatistics = payload;
    },
    setDoorphone: (state, payload) => {
      state.doorphone = payload;
    },
    setDoorphoneEditDoorphone: (state, payload) => {
      state.doorphoneEditDoorphone = payload;
    },
    setDoorphoneEditInfo: (state, payload) => {
      state.doorphoneEditInfo = payload;
    },
    setDoorphoneExpanded: (state, payload) => {
      state.doorphoneExpanded = payload;
    },
    setSipCode: (state, payload) => {
      state.doorphone.sip_status = payload;
    },
    addSipHistory: (state, payload) => {
      state.sipHistory = payload;
    },
    setRules: (state, payload) => {
      state.rules = payload;
    },
    setSoundSettings: (state, payload) => {
      state.soundSettings = payload;
    },
    setTimeSettings: (state, payload) => {
      state.timeSettings = payload;
    },
    setJournalsip: (state, payload) => {
      state.journalsip = payload;
    },
    setJournalSipAllBeward: (state, payload) => {
      state.journalSipAllBeward = payload;
    },
    setJournalSipAllExtended: (state, payload) => {
      state.journalSipAllExtended = payload;
    },
    setCities: (state, payload) => {
      state.cities = payload;
    },
    setStreets: (state, payload) => {
      state.streets = payload;
    },
    setHouses: (state, payload) => {
      state.houses = payload;
    },
    setAddresses: (state, payload) => {
      state.addresses = payload;
    },
    setDistricts: (state, payload) => {
      state.districts = payload;
    },
    setTextmessage: (state, payload) => {
      state.textmessage = payload;
    },
    setFreeKeys: (state, payload) => {
      state.freeKeys = payload;
    },
    setFreeUniversalKeys: (state, payload) => {
      state.freeUniversalKeys = payload;
    },
    setRelay: (state, payload) => {
      state.relay = payload;
    },
    setActions: (state, payload) => {
      state.actions = payload;
    },
    setTempCodeProvisionHistory: (state, payload) => {
      state.tempCodeProvisionHistory = Array.isArray(payload) ? payload : [];
    },
    setAudioUpload: (state, payload) => {
      state.audio = payload;
    },
    setDetailInfoAudioUpload: (state, payload) => {
      state.detailAudio = payload;
    },
  },
  actions: {
    getDoorphones (state, options = {}) {
      return new Promise((resolve, reject) => {
        Doorphone.getDoorphones(options)
          .then(({ data }) => {
            state.commit('setDoorphones', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getAllSCUD (state, options = {}) {
      return new Promise((resolve, reject) => {
        Doorphone.getAllSCUD(options)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getMapDoorphones (state, options = {}) {
      return new Promise((resolve, reject) => {
        Doorphone.getMapDoorphones(options)
          .then(({ data }) => {
            state.commit('setMapDoorphones', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getDevicesCoordinates (state, options = {}) {
      return new Promise((resolve, reject) => {
        Doorphone.getMapDoorphones(options)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getMfDoorphones (state, options = {}) {
      return new Promise((resolve, reject) => {
        Doorphone.getMfDoorphones(options)
          .then(({ data }) => {
            state.commit('setMfDoorphones', data.doorphones);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getExpandedDoorphones (state, options = {}) {
      return new Promise((resolve, reject) => {
        Doorphone.getExpandedDoorphones(options)
          .then(({ data }) => {
            state.commit('setDoorphonesExpanded', data.doorphones);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getDoorphoneVideo (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getDoorphoneVideo(id)
          .then(({ data }) => {
            resolve(data.channel.stream_url);
          })
          .catch(e => reject(e));
      });
    },
    getDoorphone (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.getDoorphone(id)
          .then((response) => {
            state.commit('setDoorphone', response);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getExpandedDoorphone (state, { id, options = {} }) {
      return new Promise((resolve, reject) => {
        Doorphone.getExpandedDoorphone(id, options)
          .then((response) => {
            state.commit('setDoorphoneExpanded', response);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getSipHistory (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getSipHistory(id)
          .then((response) => {
            state.commit('addSipHistory', response.data.data);
            resolve(response.data.data);
          })
          .catch(e => reject(e));
      });
    },
    exportSipHistoryCsv (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.exportSipHistoryCsv(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getSipStatus (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getSipStatus(id)
          .then((response) => {
            state.commit('setSipCode', response.data.sip_status);
            resolve(response.data.sip_status);
          })
          .catch(e => reject(e));
      });
    },
    getRules (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getRules(id)
          .then((response) => {
            state.commit('setRules', response.rules.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    importRules (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.importRules(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateRules (state, { id, rules }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateRules(id, rules)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateApartmentsBeward (state, { id, rules }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateApartmentsBeward(id, rules)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getSoundSettings (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getSoundSettings(id)
          .then((response) => {
            state.commit('setSoundSettings', response.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateSoundSettings (state, { id, settings }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateSoundSettings(id, settings)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    massUpdateSoundSettings (state, { doorphones, settings }) {
      return new Promise((resolve, reject) => {
        Doorphone.massUpdateSoundSettings(doorphones, settings)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getTimeSettings (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getTimeSettings(id)
          .then((response) => {
            state.commit('setTimeSettings', response.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateTimeSettings (state, { id, settings }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateTimeSettings(id, settings)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getJournalsip (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getJournalsip(id)
          .then((response) => {
            state.commit('setJournalsip', response.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getJournalSipAllBeward (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getJournalSipAllBeward(id)
          .then((response) => {
            state.commit('setJournalSipAllBeward', response.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getJournalSipAllExtended (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getJournalSipAllBeward(id)
          .then((response) => {
            state.commit('setJournalSipAllExtended', response.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    syncJournalSipExtended (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.syncJournalSipExtended(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    newDoorphone (state, doorphone) {
      return new Promise((resolve, reject) => {
        Doorphone.newDoorphone(doorphone)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    additionalDoorphone (state, doorphone) {
      return new Promise((resolve, reject) => {
        Doorphone.additionalDoorphone(doorphone)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateDoorphone (state, { id, doorphone }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateDoorphone(id, doorphone)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateCoordsDoorphone (state, { id, doorphone }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateCoordsDoorphone(id, doorphone)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteDoorphone (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.deleteDoorphone(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getAddressSearch (state, { value }) {
      return new Promise((resolve, reject) => {
        Doorphone.getAddressSearch({ value })
          .then((response) => {
            state.commit('setAddresses', Object.values(response.addresses));
            state.commit('setDistricts', Object.values(response.districts));
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getCities (state, { city_name, type }) {
      return new Promise((resolve, reject) => {
        Doorphone.getCities({ city_name, type })
          .then((response) => {
            state.commit('setCities', response);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getStreets (state, { street_name, city_id, type }) {
      return new Promise((resolve, reject) => {
        Doorphone.getStreets({ street_name, city_id, type })
          .then((response) => {
            state.commit('setStreets', response);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getHouses (state, { house_name, street_id, type }) {
      return new Promise((resolve, reject) => {
        Doorphone.getHouses({ house_name, street_id, type })
          .then((response) => {
            state.commit('setHouses', response);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    uploadMassDoorsound (state, formData) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadMassDoorsound(formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadDoorsound (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadDoorsound(id, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadErrorSound (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadErrorSound(id, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadKeypressSound (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadKeypressSound(id, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadCustomSound (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadCustomSound(id, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadEmergencySound (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadEmergencySound(id, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadMassRingsound (state, formData) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadMassRingsound(formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadOpenDoorSound (state, formData) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadOpenDoorSound(formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadRingsound (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadRingsound(id, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadTextmessage (state, { text, id, isEnabled }) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadTextmessage(text, id, isEnabled)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    setMassAutoKey (state, { toggle, outputsSet, doorphones }) {
      return new Promise((resolve, reject) => {
        Doorphone.setMassAutoKey(toggle, outputsSet, doorphones)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    uploadMassTextmessage (state, { text, doorphones, start_date, end_date }) {
      return new Promise((resolve, reject) => {
        Doorphone.uploadMassTextmessage(text, doorphones, { start_date, end_date })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    massAttachUniversalKey (state, { doorphones, keys }) {
      return new Promise((resolve, reject) => {
        Doorphone.massAttachUniversalKey(doorphones, keys)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getTextmessage (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getTextmessage(id)
          .then((response) => {
            state.commit('setTextmessage', response);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getDoorsound (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getDoorsound(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getRingsound (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getRingsound(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    openDoor (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.openDoor(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    openDoors (state, formData) {
      return new Promise((resolve, reject) => {
        Doorphone.openDoors(formData)
          .then((response) => {
            resolve(response);
            this.doorinfo = response.data;
          })
          .catch(e => reject(e));
      });
    },
    getFreeKeys (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getFreeKeys(id)
          .then((response) => {
            state.commit('setFreeKeys', response.keys);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getAutoKeyCollection (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getAutoKeyCollection(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getFreeUniversalKeys (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getFreeUniversalKeys(id)
          .then((response) => {
            state.commit('setFreeUniversalKeys', response.keys);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    addKey (state, { doorphoneId, keyId, duplicate }) {
      return new Promise((resolve, reject) => {
        Doorphone.addKey(doorphoneId, keyId, duplicate)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    detachKey (state, { doorphoneId, keyId, duplicate }) {
      return new Promise((resolve, reject) => {
        Doorphone.detachKey(doorphoneId, keyId, duplicate)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    deleteKeysByCsv (state, { doorphoneId, formData }) {
      return new Promise((resolve, reject) => {
        Doorphone.deleteKeysByCsv(doorphoneId, formData)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    exportCsv (state) {
      return new Promise((resolve, reject) => {
        Doorphone.exportCsv()
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    changeDevice (state, { doorphoneId, deviceId }) {
      return new Promise((resolve, reject) => {
        Doorphone.changeDevice(doorphoneId, deviceId)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getRelay (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getRelay(id)
          .then((response) => {
            state.commit('setRelay', response.data);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateRelay (state, { id, data }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateRelay(id, data)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    importRelay (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.importRelay(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    changeAddress (state, { id, data }) {
      return new Promise((resolve, reject) => {
        Doorphone.changeAddress(id, data)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    rebootDoorphone (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.rebootDoorphone(id)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    massRebootDoorphone (state, { doorphones }) {
      return new Promise((resolve, reject) => {
        Doorphone.massRebootDoorphone(doorphones)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    analyticsInfo (state, { id }) {
      return Doorphone.analyticsInfo({ id });
    },
    changeAnalyticsParams (state, { id, ...params }) {
      return Doorphone.changeAnalyticsParams({ id, ...params });
    },
    getCallStart (state, { doorphoneId, apartment, target }) {
      return new Promise((resolve, reject) => {
        Doorphone.getCallStart(doorphoneId, apartment, target)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getCallEnd (state, { doorphoneId }) {
      return new Promise((resolve, reject) => {
        Doorphone.getCallEnd(doorphoneId)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    callCheck (state, { doorphoneId }) {
      return new Promise((resolve, reject) => {
        Doorphone.callCheck(doorphoneId)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateServiceDoorCode (state, { id, serviceDoorCode, lifetimeDays, rotationLocked, rotationComment }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateServiceDoorCode(id, serviceDoorCode, lifetimeDays, rotationLocked, rotationComment)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getServiceCode (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.getServiceCode(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateServiceCode (state, { id, pass }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateServiceCode(id, pass)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateScanByCode (state, { id, scanByCode }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateScanByCode(id, scanByCode)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getConciergeNumber (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.getConciergeNumber(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateConciergeNumber (state, { id, conciergeNumber }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateConciergeNumber(id, conciergeNumber)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    changeApartments (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.changeApartments(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    heatingView (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.heatingView(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    editHeating (state, { id, cHeatThresHold, cHeatSwitch }) {
      return new Promise((resolve, reject) => {
        Doorphone.editHeating(id, cHeatThresHold, cHeatSwitch)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getSoundSettingsBeward (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getSoundSettingsBeward(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateSoundSettingsBeward (state, { id, settings }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateSoundSettingsBeward(id, settings)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getActions (state, { id, options = {} }) {
      return new Promise((resolve, reject) => {
        Doorphone.getActions(id, options)
          .then((data) => {
            state.commit('setActions', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    audioUpload (state, { options = {} }) {
      return new Promise((resolve, reject) => {
        Doorphone.audioUpload(options)
          .then((data) => {
            state.commit('setAudioUpload', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    dwdrView (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.dwdrView(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    detailInfoAudioUpload (state, { massUploadId, options = {} }) {
      return new Promise((resolve, reject) => {
        Doorphone.detailInfoAudioUpload(massUploadId, options)
          .then((data) => {
            state.commit('setDetailInfoAudioUpload', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    viewLCDSettings (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.viewLCDSettings(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    editLCDSettings (state, { id, formData }) {
      return new Promise((resolve, reject) => {
        Doorphone.editLCDSettings(id, formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    editDWDR (state, { id, DWDR, DWDRLevel }) {
      return new Promise((resolve, reject) => {
        Doorphone.editDWDR(id, DWDR, DWDRLevel)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    sipStatistics (state, { dateFrom, dateTo }) {
      return new Promise((resolve, reject) => {
        Doorphone.sipStatistics(dateTo, dateFrom)
          .then((data) => {
            state.commit('setLogsStatistics', data.data.logs);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getSipStatusLogs (state, { dateFrom, dateTo }) {
      return new Promise((resolve, reject) => {
        Doorphone.getSipStatusLogs(dateTo, dateFrom)
          .then((data) => {
            state.commit('setSipStatusLogs', data.data.logs);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    changeAgent (state, { id, agentId }) {
      return new Promise((resolve, reject) => {
        Doorphone.changeAgent(id, agentId)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateSnapshot (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateSnapshot(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getTempCode (state, { id, form }) {
      return new Promise((resolve, reject) => {
        Doorphone.getTempCode(id, form)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    installDoorOpeningTime (state, { id, wait }) {
      return new Promise((resolve, reject) => {
        Doorphone.installDoorOpeningTime(id, wait)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    activateDoorphone (state, { doorphoneId, form }) {
      return new Promise((resolve, reject) => {
        Doorphone.activateDoorphone(doorphoneId, form)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    testActivateDoorphone (state, { doorphoneId, form }) {
      return new Promise((resolve, reject) => {
        Doorphone.testActivateDoorphone(doorphoneId, form)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    lkActivateDoorphone (state, { doorphoneId, form }) {
      return new Promise((resolve, reject) => {
        Doorphone.lkActivateDoorphone(doorphoneId, form)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getTimeOpeningDoor (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getTimeOpeningDoor(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getCheckCameras (state) {
      return new Promise((resolve, reject) => {
        Doorphone.getCheckCameras()
          .then((data) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getAnalogLineAnalysis (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getAnalogLineAnalysis(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getInfoDoorphoneEdit (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.getInfoDoorphoneEdit(id)
          .then((response) => {
            state.commit('setDoorphoneEditInfo', response);
            state.commit('setDoorphoneEditDoorphone', response.doorphone);
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    updateAnalogLineAnalysis (state, { id, data }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateAnalogLineAnalysis(id, data)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getAnalogLineApartmentSettings (state, { id, apartment }) {
      return new Promise((resolve, reject) => {
        Doorphone.getAnalogLineApartmentSettings(id, apartment)
          .then((data) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateAnalogLineApartmentSettings (state, { id, data }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateAnalogLineApartmentSettings(id, data)
          .then((data) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getMeasurementAnalogLine (state, { id, number, numberTo }) {
      return new Promise((resolve, reject) => {
        Doorphone.getMeasurementAnalogLine(id, { number, numberTo })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    stopMeasurementAnalogLine (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.stopMeasurementAnalogLine(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateNtpAddress (state, { selectedTmp }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateNtpAddress({ selectedTmp })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateMassLsdSettings (state, formData) {
      return new Promise((resolve, reject) => {
        Doorphone.updateMassLsdSettings(formData)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    openDoorSoundReset (state, { doorphones }) {
      return new Promise((resolve, reject) => {
        Doorphone.openDoorSoundReset({ doorphones })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    massResetLcdImage (state, { doorphones }) {
      return new Promise((resolve, reject) => {
        Doorphone.massResetLcdImage({ doorphones })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateAudioMessage (state, { id, volume }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateAudioMessage(id, volume)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getCustomMode (state, { id }) {
      return new Promise((resolve, reject) => {
        Doorphone.getCustomMode(id)
          .then((data) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getAudioMessage (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getAudioMessage(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    setCustomMode (state, { id, isEnabledMode }) {
      return new Promise((resolve, reject) => {
        Doorphone.setCustomMode(id, isEnabledMode)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getAnalogLineBeward (state, id) {
      return new Promise((resolve, reject) => {
        Doorphone.getAnalogLineBeward(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateAnalogLineBeward (state, { id, data }) {
      return new Promise((resolve, reject) => {
        Doorphone.updateAnalogLineBeward(id, data)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    checkAnalogLineBeward (state, { id, number }) {
      return new Promise((resolve, reject) => {
        Doorphone.checkAnalogLineBeward(id, number)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    showRuleSipSettings (state, idDoorphone) {
      return new Promise((resolve, reject) => {
        Doorphone.showRuleSipSettings(idDoorphone)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(error => reject(error));
      });
    },
    getCodeApartment (state, { id, number }) {
      return new Promise((resolve, reject) => {
        Doorphone.getCodeApartment(id, number)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(error => reject(error));
      });
    },
    setCodeApartment (state, { id, number }) {
      return new Promise((resolve, reject) => {
        Doorphone.setCodeApartment(id, number)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateCodesFromDoorphone (state, { id }) {
      return Doorphone.updateCodesFromDoorphone(id);
    },
    syncMainDoorphoneCodes (state, { id }) {
      return Doorphone.syncMainDoorphoneCodes(id);
    },
    massSipStatus (state, payload) {
      return new Promise((resolve, reject) => {
        Doorphone.massSipStatus(payload)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    getSipCacheStatistics (state, params) {
      return new Promise((resolve, reject) => {
        Doorphone.getSipCacheStatistics(params)
          .then((data) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    fetchTempCodeProvisionHistory (ctx, { doorphoneId, page = 1, perPage = 20, filters = {} }) {
      return new Promise((resolve, reject) => {
        const opts = { page, limit: perPage, filters };
        const req = doorphoneId != null && doorphoneId !== ''
          ? Doorphone.getTempCodeProvisionHistory(doorphoneId, opts)
          : Doorphone.getTempCodeProvisionHistoryAll(opts);
        req
          .then((data) => {
            const list = data && Array.isArray(data.data) ? data.data : [];
            ctx.commit('setTempCodeProvisionHistory', list);
            resolve(data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchServiceDoorCodeHistory (ctx, { doorphoneId, page = 1, perPage = 20, filters = {} }) {
      return new Promise((resolve, reject) => {
        const opts = { page, limit: perPage, filters };
        const req = doorphoneId != null && doorphoneId !== ''
          ? Doorphone.getServiceDoorCodeHistory(doorphoneId, opts)
          : Doorphone.getServiceDoorCodeHistoryAll(opts);
        req
          .then((data) => resolve(data))
          .catch((e) => reject(e));
      });
    },
  },
};
